export const SEARCH_MODAL_ITEM_KIND = {
  Documentation: 'documentation',
  Glossary: 'glossary',
  QuickStart: 'quick-start',
  Service: 'service',
  Graft: 'graft',
  Module: 'module',
  Gateway: 'gateway',
  Action: 'action',
} as const
